/**
 * Normaliza distintos formatos de entrada geoespacial
 * a un GeoJSON FeatureCollection.
 *
 * Soporta:
 * - Objetos con Shape o shape en formato WKT
 * - Objetos con la propiedad geojson
 * - GeoJSON Feature
 * - GeoJSON FeatureCollection
 * - Arrays de Features
 *
 * Las geometrías WKT son convertidas mediante polygonToGeoJSON.
 *
 * @param {*} item - Entrada a normalizar.
 * @param {string|number} layerId - Identificador utilizado al generar propiedades por defecto.
 * @param {boolean} isUTM - Indica si las coordenadas WKT están en UTM.
 * @param {object} deps - Dependencias requeridas.
 * @param {Function} deps.polygonToGeoJSON
 * @param {Function} deps.normalizeGeoInput
 *
 * @returns {GeoJSON.FeatureCollection|null}
 */
export function normalizeLayerInputToFeatureCollection(item, layerId, isUTM, deps) {
    try {
        const { polygonToGeoJSON, normalizeGeoInput } = deps;

        if (typeof (item?.Shape ?? item?.shape) === "string") {
            return polygonToGeoJSON(item.Shape ?? item.shape, {
                isUTM,
                properties: { id: layerId, ...(item.properties || {}) },
            });
        }

        if (item?.geojson) {
            return normalizeGeoInput(
                item.geojson,
                item.properties || { id: layerId },
            );
        }

        if (item?.type === "Feature") return normalizeGeoInput(item);
        if (item?.type === "FeatureCollection") {
            return normalizeGeoInput(item);
        }
        if (Array.isArray(item)) return normalizeGeoInput(item);

        return null;
    } catch (err) {
        console.error("Error al normalizar entrada de capa:", err);
        return null;
    }

}

